export class PGTransaction {
  fromDate: string;
  toDate: string;
  pageSize: number;
  pageIndex: number;
  mode: string;
}

export class PgFilterOption {
  fromDate: string;
  toDate: string;
  pageSize: number;
  pageIndex: number;
  merchantName: string;
  paymentMethod: string;
  transactionId: string;
  bankTransactionId: string;
  bankReferenceId: string;
  orderId: string;
}

export class PGTransactionReportVM {
  fromDate: string;
  toDate: string;
  pageSize: number;
  pageIndex: number;
  merchantName: string;
  paymentMethod: string;
  transactionId: string;
  bankTransactionId: string;
  bankReferenceId: string;
  orderId: string;
  txns_status: string;
}

export class PGTransactionReportDownloadVM {
  fromDate: string;
  toDate: string;
}


export class Detail {
  secure_token: string;
  insert_tms: string;
  merchant_name: string;
  cust_name: string;
  cust_mobile: string;
  cust_email: string;
  txns_status: string;
  bank_status: string;
  selected_pi_type: string;
  payee_mode: string;
  selected_pi_name: string;
  card_account_no: string;
  cardholdername: string;
  txns_id: string;
  txns_amount: number;
  pi_charges: number;
  pi_ekpay_charges: number;
  pi_discount_amount: number;
  pi_discount_promo_amount: number;
  total_paid_amount: number;
  req_tms: Date;
  success_url: string;
  fail_url: string;
  cancel_url: string;
  ipn_url: string;
  ip_address: string;
  user_agent: string;
  merchant_txns_id: string;
  bank_trx_id: string;
  order_description: string;
  challan_number: string;
}

export class BkashRefund {
  id: number;
  bank_trnx_id: string;
  ekpay_trnx_id: string;
  refundTransactionId: string;
  refundAmount: number;
  refund_status: string;
  refunded_on: string;
}


export class Disbursement {
  id: number;
  bank_trnx_id: string;
  ekpay_trnx_id: string;
  refundTransactionId: string;
  amount: string;
  receiver_msisdn: string;
  status: string;
  disbursed_on: string;
}

export class DisbursementReq {
  id: number;
  bank_trnx_id: string;
  ekpay_trnx_id: string;
  amount: string;
  receiver_msisdn: string;
  status: string;
}

export class PGTransactionView {
  reason: string;
  response: string;
  pageSize: number;
  pageIndex: number;
  totalRecords: number;
  details: Detail[];
}

export class LoadBkashRefundTransacionsView {
  status: string;
  message: string;
  pageSize: number;
  pageIndex: number;
  totalRecords: number;
  data: BkashRefund[];
}


export class LoadDisbursementListView {
  status: string;
  message: string;
  pageSize: number;
  pageIndex: number;
  totalRecords: number;
  data: Disbursement[];
}

export class BkashRefundRes {
  ekpay_id: string;
  reason: string;
  status: string;
}

export class BkashDeleteRefundRes {
  status: string;
  message: string;
}

export class PayoutRequest {
  amount: string;
  currency: string;
  merchantInvoiceNumber: string;
  receiverMSISDN: string;
  bank_trnx_id: string;
}

export class TransferRequest {
  amount: string;
  currency: string;
  transferType: string;
}

export class TransferRequestRes {
  amount: string;
  completedTime: string;
  transactionStatus: string;
  transferType: string;
  trxID: string;
  errorCode: string;
  errorMessage: string;
}

export class PayoutRequestRes {
  trxID: string;
  transactionStatus: string;
  amount: string;
  currency: string;
  merchantInvoiceNumber: string;
  completedTime: string;
  receiverMSISDN: string;
  b2cFee: string;
  errorCode: string;
  errorMessage: string;
}

export class BkashRefundConfirm {
  bkashTrnxId: string;
  ekpayTrnxId: string;
}

export class BkashRefundConfirmRes {
  completedTime: string;
  transactionStatus: string;
  originalTrxID: string;
  refundTrxID: string;
  amount: string;
  currency: string;
  charge: string;
  errorCode: string;
  errorMessage: string;
}

export class BkashRefundStatus {
  paymentID: string;
  trxID: string;
}

export class OrganizationBalance {
  accountTypeName: string;
  accountStatus: string;
  accountHolderName: string;
  currency: string;
  currentBalance: string;
  availableBalance: string;
  updateTime: string;
}

export class BkashWalletBalanceRes {
  organizationBalance: OrganizationBalance[];
  errorCode: string;
  errorMessage: string;
}

export const MERCHANT_NAME = [
  'ac_1',
  'ac_10',
  'ac_12',
  'ac_13',
  'ac_15',
  'ac_18',
  'ac_19',
  'ac_22',
  'ac_26',
  'ac_27',
  'ac_29',
  'ac_30',
  'ac_32',
  'ac_33',
  'ac_35',
  'ac_36',
  'ac_38',
  'ac_39',
  'ac_4',
  'ac_41',
  'ac_42',
  'ac_44',
  'ac_47',
  'ac_48',
  'ac_49',
  'ac_50',
  'ac_51',
  'ac_52',
  'ac_54',
  'ac_55',
  'ac_56',
  'ac_57',
  'ac_58',
  'ac_59',
  'ac_6',
  'ac_61',
  'ac_64',
  'ac_65',
  'ac_67',
  'ac_68',
  'ac_69',
  'ac_70',
  'ac_72',
  'ac_73',
  'ac_75',
  'ac_76',
  'ac_77',
  'ac_78',
  'ac_79',
  'ac_81',
  'ac_82',
  'ac_85',
  'ac_86',
  'ac_87',
  'ac_88',
  'ac_89',
  'ac_9',
  'ac_90',
  'ac_91',
  'ac_93',
  'ac_94',
  'ac_min',
  'amarpay_sapi',
  'bankasia',
  'banknasia',
  'bbs_sdscms',
  'bscic_ereg',
  'bsc_payment',
  'bup_mer',
  'cityagent_sapi',
  'copotronic',
  'copotronic1',
  'copotronic_bmeb',
  'copotronic_bmeb_01',
  'copotronic_comilla',
  'copotronic_comilla_01',
  'copotronic_ctg',
  'copotronic_ctg_01',
  'dae_challan',
  'dae_fee',
  'dae_fee01',
  'dae_pesticide',
  'desco_ams',
  'desco_load',
  'desco_ocsms',
  'digi_chandpur',
  'dmoney_sapi',
  'donation7894',
  'donation-app',
  'easypayment_mer',
  'easypay_sapi',
  'ecopyright_mer',
  'ekdesh_pay',
  'ekhsheba-sarkar',
  'ekpaycore',
  'ekpaycoretest',
  'eksheba',
  'ekshop_mer',
  'emutation_land',
  'epassport',
  'epassport_usd',
  'farid_muni_koica',
  'gopal_muni_koica',
  'greenred_sapi',
  'hajidanesh_mer',
  'jhena_muni_koica',
  'land_kiosk_003',
  'land_kiosk_005',
  'land_kiosk_006',
  'land_kiosk_007',
  'land_kiosk_008',
  'land_kiosk_009',
  'land_kiosk_010',
  'landp3124',
  'land_port_test',
  'land_tax',
  'lima_mer',
  'mercantile_sapi',
  'midland_sapi',
  'minagri_reg',
  'minagri_seed',
  'min_forest_sundarban',
  'minfrst_sundarban_east',
  'mins_agri',
  'muktopath',
  'mymen_muni_koica',
  'natore_muni_koica',
  'ngd843h@u893',
  'nise_mer',
  'nrb_sapi',
  'nsda_mer',
  'okwallet_sapi',
  'padmabank_sapi',
  'paystation_sapi',
  'pbl_sapi',
  'pir_muni_koica',
  'qcash_sapi',
  'ramgoti_muni_koica',
  'sah_75',
  'sebaautom_mer',
  'singra_muni_koica',
  'tap_sapi',
  'tarabo_muni_koica',
  'teprihcl_mer',
  'teprimcs_mer',
  'tetulia_mer',
  'tungi_muni_koica',
  'upay_sapi',
  'women_ivhostel'
];



// WEBPACK FOOTER //
// ./src/app/report/pg-detailed-transaction-report/pg-transaction-view.ts